import React, { useEffect, useState } from "react";
import Lottie from "lottie-react";
import loader from "../../assets/loader.json";
import { DataGrid } from "@mui/x-data-grid";
import { FiDownload } from "react-icons/fi";
import * as XLSX from "xlsx";

const Wallet = ({ id, wallet, addr, canWrite }) => {
  const [walletData, setWalletData] = useState([]);
  const [user_address, setuser_address] = useState([]);
  
  useEffect(() => {
    if (wallet) {
      setWalletData(wallet);
    }
  }, [wallet]);

  // Create rows for the new wallet data format
  const rows = walletData.map((item, index) => ({
    id: index + 1,
    currency: item.symbol || "-",
     Balance: item.amount ?? 0,
    hold: item.hold ?? 0,
      plan1hold: item.plan1hold ?? 0,
      plan2hold: item.plan2hold ?? 0,
      plan3hold: item.plan3hold ?? 0,
      total: item.total ?? 0,
    // Format balance with proper decimal places
    formattedBalance: typeof item.balance === 'number' 
      ? item.balance.toLocaleString('en-US', { 
          minimumFractionDigits: 2, 
          maximumFractionDigits: 8 
        })
      : item.balance ?? 0,
     

  }));

  const columns = [
    { field: "currency", headerName: "Currency", flex: 1, minWidth: 150 },
    { 
      field: "formattedBalance", 
      headerName: "Balance", 
      flex: 1, 
      minWidth: 150,
      renderCell: (params) => (
        <span className="font-semibold text-green-600">
          {params.value}
        </span>
      )
    },
    { field: "hold", headerName: "Hold", flex: 1, minWidth: 150 },
    { field: "plan1hold", headerName: "plan1hold", flex: 1, minWidth: 150 },
    { field: "plan2hold", headerName: "plan2hold", flex: 1, minWidth: 150  },
    { field: "plan3hold", headerName: "plan3hold", flex: 1, minWidth: 150 },
    { field: "total", headerName: "Total", flex: 1, minWidth: 150},
    
  ];

  const handleExport = () => {
    if (!walletData.length) return;

    const exportRows = walletData.map((item, index) => ({
      "S.No": index + 1,
      "Currency": item.symbol || "-",
      "Balance": item.amount ?? 0,
      "Hold": item.hold ?? 0,
      "Plan1Hold": item.plan1hold ?? 0,
      "Plan2Hold": item.plan2hold ?? 0,
      "plan3hold": item.plan3hold ?? 0,
      "Total": item.total ?? 0,
    }));

    const ws = XLSX.utils.json_to_sheet(exportRows);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Wallet");
    XLSX.writeFile(wb, `Wallet_${id || "user"}.xlsx`);
  };

  const style = {
    height: 100,
    width: 100,
    margin: "auto",
    alignItems: "center",
  };

  // Calculate total balance across all currencies
  const totalBalance = walletData.reduce((sum, item) => sum + (item.balance || 0), 0);

  return !wallet ? (
    <Lottie animationData={loader} style={style} loop={true} />
  ) : (
    <div className="w-[80vw] mx-auto h-full">
      <div className="w-full mt-[10px] border">
        <div className="flex justify-between p-5 text-blue-900 font-bold">
          <h1 className="text-2xl">Wallet</h1>
          <button
            onClick={handleExport}
            className="flex items-center gap-2 px-3 py-1 bg-blue-600 hover:bg-blue-700 text-white rounded shadow text-sm"
          >
            <FiDownload className="w-5 h-5" />
            Export
          </button>
        </div>
        
        {/* Wallet Summary */}
        {/* <div className="bg-gray-50 p-4 border-b">
          <div className="flex justify-between items-center">
            <div>
              <h2 className="text-lg font-semibold text-gray-700">Wallet Summary</h2>
              <p className="text-sm text-gray-500">
                Total Currencies: {walletData.length}
              </p>
            </div>
            <div className="text-right">
              <p className="text-sm text-gray-500">Total Balance</p>
              <p className="text-xl font-bold text-green-600">
                {totalBalance.toLocaleString('en-US', { 
                  minimumFractionDigits: 2, 
                  maximumFractionDigits: 8 
                })}
              </p>
            </div>
          </div>
        </div> */}

        {/* Address Display */}
        {addr && addr.length > 0 && (
          <div className="flex justify-between p-5 text-blue-900 font-bold border-b">
            <h1 className="text-1xl">Address: {addr[0]?.address || '-'}</h1>
          </div>
        )}

        {/* Wallet Data Grid */}
        <div className="p-4">
          <DataGrid
            columns={columns}
            rows={rows}
            getRowId={(row) => row.id}
            pageSize={10}
            autoHeight
            rowHeight={50}
            disableSelectionOnClick
            sx={{
              '& .MuiDataGrid-cell': {
                borderBottom: '1px solid #e5e7eb',
              },
              '& .MuiDataGrid-columnHeaders': {
                backgroundColor: '#f3f4f6',
                borderBottom: '2px solid #d1d5db',
              },
            }}
          />
        </div>

        {/* No Data Message */}
        {walletData.length === 0 && (
          <div className="p-8 text-center">
            <p className="text-gray-500 text-lg">No wallet data available</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Wallet;
